import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Checkbox,
  createStyles,
  Dialog,
  DialogContent,
  DialogActions,
  FormControl,
  FormControlLabel,
  IconButton,
  Button,
  InputAdornment,
  InputBase,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Theme,
  Toolbar,
  Tooltip,
  Typography,
  WithStyles,
  InputLabel,
} from "@material-ui/core";
import {
  AddCircle as Add,
  Close,
  HighlightOff,
  PersonAdd,
  RemoveCircle,
  Search,
  PictureAsPdf,
  Edit as EditIcon,
  ArrowUpward,
  ArrowDownward,
  Sort,
  Delete,
} from "@material-ui/icons";
import { searchPlayers, addPlayerToFav, removePlayerFromFav } from "../../actions";
import { TightBodyCell, TightHeaderCell } from "../SharedComponents/CustomTableElements";
import GameActions from "../../actions/games";
import PaymentAction from "../../actions/payments";
import { GlobalState } from "../../types/globalState";
import { showPickerDialog } from "../SharedComponents/PickerDialog";
import TeamActions from "../../actions/teams";
import GroupCreation from "../Groups/GroupCreation";
import { showSnackbar } from "../SharedComponents/Notifier";
import { Game, IndexedGames, PaymentType } from "./../../types/game";
import { ErrorOnlyCallback } from "../../types/actions";
import { User, Rules } from "../../types/user";
import { PlayingAsFormats, PlayingFormats } from "../../types/competition";
import * as socket from "../../socket";
import { showAlertDialog } from "../SharedComponents/AlertDialog";
import { Player, PayStatus } from "../../types/player";
import DialogToolbar from "components/SharedComponents/DialogToolbar";
import PlayerName from "components/SharedComponents/PlayerName";
import PaymentStatusBadge from "components/SharedComponents/PaymentStatusBadge";
import RemoveDialogContent from "./RemoveDialogContent";
import GuestPlayerForm from "./GuestPlayerForm";
import { GuestPlayerInputs } from "types/player";
import { Team } from "types/team";
import { getHandicapDisplay, sortByGroupName } from "utils";
import { isRangeGame } from "../../utils/rhiGame";
import PayBeforePlayAddPlayerChoice, {
  AddPlayerCreditOffer,
  AddPlayerCreditVoucher,
  PayBeforePlayAddChoice,
} from "./PayBeforePlayAddPlayerChoice";
import VideoPopup from "components/SharedComponents/VideoPopup";
import { HELP_VIDEOS } from "consts";
import config from "../../config";
import { sortPlayersBySearchPriority } from "../../utils/playerFavourites";
import { PlayerFavouriteToggle } from "../SharedComponents/PlayerFavouriteToggle";
import paymentApi from "../../api/payment";
import { GameCredit } from "../../types/gameCredit";
interface Props extends WithStyles {
  updatePlayersPH(id: string, playerIds: string[]): void;
  addPlayer(id: string, playerId: string, itsMe: boolean, callback?: ErrorOnlyCallback): void;
  addGuestPlayer(id: string, inputs: GuestPlayerInputs, callback?: ErrorOnlyCallback): void;
  insertTeam(name: string, gameId: string, color?: string, callback?: any): void;
  updateTeam(teamId: string, gameId: string, name: string, color?: string): void;
  searchPlayersByUserName(username: string, callback: any): void;
  addPlayerToFav?(playerId: string, callback?: (err: any) => void): void;
  removePlayerFromFav?(playerId: string, callback?: (err: any) => void): void;
  removePlayer(id: string, playerId: string, cb?: () => void, issueCredit?: boolean): void;
  insertGroup(id: string, name: string, playersId: string[], callback?: ErrorOnlyCallback): void;
  updateGameGroup(id: string, group: string, oldName: string, playerIds: string[]): void;
  addPlayerToGroup(id: string, group: string, playerId: string): void;
  updateGroupStartingHole(id: string, startingHole: number, playerId: string, teamId?: string): void;
  changePlayerTeam(id: string, playerId: string, teamId: string): void;
  removePlayerFromGroup(id: string, group: string, playerId: string): void;
  setUpdatedResult(game: any): void;
  getGamePlayers(id: string, cb?: VoidFunction): void;
  addWithoutPayment?(
    gameId: string,
    playersId: string[],
    payStatus: PayStatus,
    callback?: ErrorOnlyCallback,
    opts?: { creditIds?: string[] },
  ): void;
  games: IndexedGames;
  gameId: string;
  /** Row/list game when the game is not in Redux (e.g. tournament-filtered list). */
  initialGame?: Game;
  minChar: number; //Minimum character to call searchPlayers
  user: User;
  players: Player[];
  isLoading: boolean;
  onSwitchClick: VoidFunction;
}

enum DialogTypes {
  REMOVE_TEAM = "REMOVE_TEAM",
  REMOVE_GROUP = "REMOVE_GROUP",
  ADD_GUEST = "ADD_GUEST",
  ADD_GROUP = "ADD_GROUP",
  SEARCH_PLAYERS = "SEARCH_PLAYERS",
  EDIT_PLAYER = "EDIT_PLAYER",
  PAY_BEFORE_PLAY_ADD = "PAY_BEFORE_PLAY_ADD",
  REMOVE_PLAYER = "REMOVE_PLAYER",
}

const creditRemainingPence = (credit: GameCredit) =>
  typeof credit.remainingPence === "number" ? credit.remainingPence : credit.amountPence;

const creditOwnerPlayerId = (credit: GameCredit | any): string => {
  const player = credit?.player;
  if (!player) return "";
  if (typeof player === "string") return player;
  if (typeof player === "object") return String(player._id || player.id || "");
  return String(player);
};

const parseOpenCredits = (res: any): GameCredit[] => {
  const body = res?.data;
  const data = Array.isArray(body)
    ? body
    : Array.isArray(body?.data)
    ? body.data
    : Array.isArray(body?.payload)
    ? body.payload
    : [];
  return data.map((credit: any) => ({
    ...credit,
    player: creditOwnerPlayerId(credit),
    remainingPence: creditRemainingPence(credit),
  }));
};

const stackCreditsForFee = (credits: GameCredit[], feePence: number) => {
  const sorted = [...credits]
    .filter(c => creditRemainingPence(c) > 0)
    .sort((a, b) => new Date(a.expiresAt).getTime() - new Date(b.expiresAt).getTime());
  let need = feePence;
  const vouchers: AddPlayerCreditVoucher[] = sorted.map(credit => {
    const remainingPence = creditRemainingPence(credit);
    const applyPence = need > 0 ? Math.min(remainingPence, need) : 0;
    if (applyPence > 0) need -= applyPence;
    return {
      _id: credit._id,
      sourceGameName: (credit.sourceGameName || "").trim() || "Prior game",
      sourceGameCode: (credit.sourceGameCode || "").trim(),
      remainingPence,
      amountPence: credit.amountPence,
      expiresAt: credit.expiresAt,
      applyPence,
    };
  });
  const applyPence = vouchers.reduce((sum, row) => sum + row.applyPence, 0);
  const availablePence = vouchers.reduce((sum, row) => sum + row.remainingPence, 0);
  return {
    creditIds: vouchers.filter(row => row.applyPence > 0).map(row => row._id),
    applyPence,
    availablePence,
    vouchers,
  };
};

const toolbarConfig = {
  [DialogTypes.REMOVE_GROUP]: {
    title: "Remove Groups",
  },
  [DialogTypes.REMOVE_TEAM]: {
    title: "Remove Teams",
  },
  [DialogTypes.SEARCH_PLAYERS]: {
    border: false,
  },
  [DialogTypes.ADD_GROUP]: {},
  [DialogTypes.ADD_GUEST]: {
    title: "Add Unregistered Player",
    secondary: true,
  },
  [DialogTypes.EDIT_PLAYER]: {
    title: "Edit Player",
  },
  [DialogTypes.PAY_BEFORE_PLAY_ADD]: {
    title: "Add player — entry fee",
  },
  [DialogTypes.REMOVE_PLAYER]: {
    title: "Remove player",
  },
};

interface EditPlayerState {
  group: string;
  teamId: string;
  startingHole: number | "";
}

interface State {
  [index: string]: any;
  searchRes: any;
  searchTxt: string;
  openDialog: boolean;
  dialogType: DialogTypes | "";
  players: any;
  order: "asc" | "desc";
  orderBy: string;
  selectedPlayer: Player | null;
  editPlayerState: EditPlayerState;
  pendingAddChoice: ((opts: { markPaidAfterAdd: boolean; creditIds?: string[] }) => void) | null;
  returnDialogType: DialogTypes | "";
  addPlayerCredit: AddPlayerCreditOffer | null;
  addPlayerCreditIds: string[];
  addPlayerCreditLoading: boolean;
  issueRemoveCredit: boolean;
}

class GamePlayersManager extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      searchRes: [],
      searchTxt: "",
      openDialog: false,
      gameId: "",
      dialogType: "",
      players: [],
      order: "asc",
      orderBy: "group",
      selectedPlayer: null,
      editPlayerState: {
        group: "",
        teamId: "",
        startingHole: "",
      },
      pendingAddChoice: null,
      returnDialogType: "",
      addPlayerCredit: null,
      addPlayerCreditIds: [],
      addPlayerCreditLoading: false,
      issueRemoveCredit: false,
    };
  }

  componentDidMount() {
    this.props.getGamePlayers(this.props.gameId, () => {
      // Notify the organiser if there are some empty teams in the game
      const game = this.getGame();
      if (
        game?.competition?.playingRules?.playingAs === PlayingAsFormats.Team &&
        (this.props.user.rule === Rules.Organiser || this.props.user.rule === Rules.Admin)
      ) {
        const unusedTeams = (game.teams ?? []).filter(tm => !this.props.players.some(p => p.team?._id === tm._id));

        if (unusedTeams.length) {
          showAlertDialog(
            "",
            `There are some teams (${unusedTeams
              .map(t => t.name)
              .join(", ")}) that have not been used. Please remove them if they are not needed.`,
            null,
          );
        }
      }
    });
    //just for combined games in case of receiving new hcps on team changes
    this.connectToWebsocket(this.props.gameId);
  }

  componentWillUnmount() {
    socket.disconnect();
  }

  onPlayersChanged = (result: any) => {
    this.props.setUpdatedResult(result);
  };

  connectToWebsocket = (gameId: any) => {
    if (socket.connect(gameId)) {
      socket.addEvent(socket.EVENTS.PLAYERS_CHANGED, this.onPlayersChanged);
    }
  };

  searchPlayers = (value: string) => {
    this.props.searchPlayersByUserName(value, (result: any, err: any) => {
      const game = this.getGame();
      const rosterIds = new Set([
        ...Object.keys(game?.players || {}),
        ...this.props.players.map(p => p._id),
      ]);
      const sorted = sortPlayersBySearchPriority(result.data || [], {
        favPlayerIds: this.props.user?.favPlayers,
        rosterPlayerIds: rosterIds,
      });
      this.setState({ searchRes: sorted });
    });
  };

  togglePlayerFavourite = (playerId: string, favourited: boolean) => {
    if (favourited) {
      this.props.removePlayerFromFav?.(playerId);
    } else {
      this.props.addPlayerToFav?.(playerId);
    }
  };
  clearPlayers = () => {
    this.setState({ players: {} });
  };
  getGame = (): Game | undefined => {
    const fromStore = this.props.games[this.props.gameId];
    if (fromStore) return fromStore;
    return this.props.initialGame;
  };

  getGroups = () => {
    const game = this.getGame();
    const groups = new Set(game?.groups || []);

    this.props.players.forEach(p => {
      if (p.group?.name) groups.add(p.group.name);
    });

    return [...groups].sort(sortByGroupName);
  };

  _getTeamNames = () => {
    const game = this.getGame();
    return [...new Set((game?.teams ?? []).map(t => t.name))];
  };

  _getUniqueTeams = () => {
    const game = this.getGame();
    return [...new Map((game?.teams ?? []).map(t => [t.name, t])).values()].sort((a, b) =>
      sortByGroupName(a.name, b.name),
    );
  };

  _onTextFieldChanged = (field: string) => (event: any) => {
    const value = event.target.value as string;
    this.setState({ [field]: value });
    if (value.length >= this.props.minChar) {
      this.searchPlayers(value);
    } else {
      this.setState({ searchRes: [] });
    }
  };

  _removePlayer = (player: any, issueCredit = false) => {
    const { gameId } = this.props;
    this.props.removePlayer(gameId, player._id, undefined, issueCredit);
  };

  _addPlayer = (
    player: any,
    guestInputs?: GuestPlayerInputs,
    cb?: () => void,
    markPaidAfterAdd = false,
    creditIds?: string[],
  ) => {
    const { gameId, user } = this.props;
    const errCallback = (error: any) => {
      if (error) {
        if (error?.response?.data.payload?.isFull) {
          this.setState({ isGameFull: true });
          showAlertDialog("Ooops!", "The game is full.", null);
        }
      } else {
        const finish = () => {
          this.props.getGamePlayers(this.props.gameId);
          if (cb) cb();
        };
        if (creditIds?.length && player?._id) {
          this.props.addWithoutPayment?.(
            gameId,
            [player._id],
            PayStatus.PAID,
            err => {
              if (err) {
                showSnackbar("Player added but credit could not be applied. Use Payment to apply it.");
              }
              finish();
            },
            { creditIds },
          );
        } else if (markPaidAfterAdd && player?._id) {
          this.props.addWithoutPayment?.(gameId, [player._id], PayStatus.PAID, err => {
            if (err) {
              showSnackbar("Player added but could not mark as paid. Mark them paid from the game menu.");
            }
            finish();
          });
        } else {
          finish();
        }
      }
    };
    // Guest player
    if (guestInputs) this.props.addGuestPlayer(gameId, guestInputs, errCallback);
    // Normal player
    else this.props.addPlayer(gameId, player._id, player._id === user._id, errCallback);
    //
    const { name, lastName } = player ? player : guestInputs;
    this.setState({ searchTxt: "", searchRes: [] });
    showSnackbar(`${name} ${lastName ? lastName : ""} has been added to the list.`);
  };

  _onTeamEdit = (team: Team) => {
    const game = this.getGame();
    if (!game) return;

    const renderColorPicker =
      game.competition.playingRules.playingAs === PlayingAsFormats.Team &&
      game.competition.playingRules.playingFormat === PlayingFormats.Matchplay;

    showPickerDialog(
      "Team name",
      "Text",
      this._handleEditTeam(team._id),
      3,
      team.name,
      null,
      true,
      false,
      renderColorPicker,
    );
  };

  _handleEditTeam = (teamId: string) => (teamName: string, color: string) => {
    console.log(teamId, teamName, color);
    const { gameId } = this.props;
    this.props.updateTeam(teamId, gameId, teamName, color);
  };

  _onGroupEdit = (player: Player) => {
    showPickerDialog(
      "Group name",
      "Text",
      this._handleEditGroup(player.group.name),
      3,
      player.group.name,
      null,
      true,
      false,
    );
  };

  _handleEditGroup = (oldName: string) => (groupName: string) => {
    const { gameId } = this.props;
    const playerIds = this.props.players.filter(p => p.group?.name === oldName).map(p => p._id);
    this.props.updateGameGroup(gameId, groupName, oldName, playerIds);
  };

  _clear = () => {
    this.setState({ searchTxt: "", searchRes: [] });
  };

  _handleAddNewTeam = (teamName: string, color?: string) => {
    const game = this.getGame();
    if (!game) return;
    this.props.insertTeam(teamName, game._id, color);
    this._toggleNewTeamDialog();
  };

  _toggleNewTeamDialog = () => {
    const game = this.getGame();
    if (!game) return;

    const renderColorPicker =
      game.competition.playingRules.playingAs === PlayingAsFormats.Team &&
      game.competition.playingRules.playingFormat === PlayingFormats.Matchplay;

    showPickerDialog("Team name", "Text", this._handleAddNewTeam, 3, null, null, true, false, renderColorPicker);
  };

  _toggleDialog = (type?: DialogTypes) => () => {
    this.setState({ openDialog: type ? true : !this.state.openDialog, dialogType: type || "" });
  };

  _onChangeTeam = (player: any, teamId: string) => {
    const game = this.getGame();
    if (game) {
      this.props.changePlayerTeam(game._id, player._id, teamId);
    }
  };

  _onChangeGroup = (player: any, group: string) => {
    const game = this.getGame();
    if (game) {
      this.props.addPlayerToGroup(this.props.gameId, group, player._id);
    }
  };

  _needsPayBeforePlayChoice = (isGuest = false) => {
    const game = this.getGame();
    return (
      !isGuest &&
      !!game?.isPaid &&
      !!game.paymentRules?.payBeforePlay &&
      !isRangeGame(game)
    );
  };

  _openPayBeforePlayChoice = (
    onChoice: (opts: { markPaidAfterAdd: boolean; creditIds?: string[] }) => void,
    returnDialogType: DialogTypes | "" = "",
    playerId?: string,
  ) => {
    this.setState({
      openDialog: true,
      dialogType: DialogTypes.PAY_BEFORE_PLAY_ADD,
      pendingAddChoice: onChoice,
      returnDialogType,
      addPlayerCredit: null,
      addPlayerCreditIds: [],
      addPlayerCreditLoading: !!playerId,
    });
    if (playerId) this._loadAddPlayerCredit(playerId);
  };

  _loadAddPlayerCredit = (playerId: string) => {
    const game = this.getGame();
    const fee = Number(game?.paymentRules?.fee);
    const feePence = Number.isFinite(fee) && fee > 0 ? Math.round(fee * 100) : 0;
    if (
      !game?.isPaid ||
      game.paymentRules?.type !== PaymentType.MULTIPLE_PLAYER ||
      isRangeGame(game) ||
      feePence < 1
    ) {
      this.setState({ addPlayerCreditLoading: false, addPlayerCredit: null, addPlayerCreditIds: [] });
      return;
    }
    paymentApi
      .getOpenGameCredits(game._id, [playerId])
      .then((res: any) => {
        const credits = parseOpenCredits(res).filter(c => creditOwnerPlayerId(c) === playerId);
        const stacked = stackCreditsForFee(credits, feePence);
        if (stacked.applyPence < 1) {
          this.setState({ addPlayerCreditLoading: false, addPlayerCredit: null, addPlayerCreditIds: [] });
          return;
        }
        this.setState({
          addPlayerCreditLoading: false,
          addPlayerCredit: {
            feePence,
            applyPence: stacked.applyPence,
            availablePence: stacked.availablePence,
            vouchers: stacked.vouchers,
          },
          addPlayerCreditIds: stacked.creditIds,
        });
      })
      .catch(() => {
        this.setState({ addPlayerCreditLoading: false, addPlayerCredit: null, addPlayerCreditIds: [] });
      });
  };

  _handlePaymentChoiceCancel = () => {
    const { returnDialogType } = this.state;
    this.setState({
      pendingAddChoice: null,
      returnDialogType: "",
      dialogType: returnDialogType || "",
      openDialog: !!returnDialogType,
      addPlayerCredit: null,
      addPlayerCreditIds: [],
      addPlayerCreditLoading: false,
    });
  };

  _handlePaymentChoice = (choice: PayBeforePlayAddChoice, creditIds?: string[]) => {
    const { pendingAddChoice } = this.state;
    if (pendingAddChoice) {
      pendingAddChoice({
        markPaidAfterAdd: choice === "paid",
        creditIds: choice === "credit" ? creditIds : undefined,
      });
    }
    this.setState({
      pendingAddChoice: null,
      returnDialogType: "",
      openDialog: false,
      dialogType: "",
      addPlayerCredit: null,
      addPlayerCreditIds: [],
      addPlayerCreditLoading: false,
    });
  };

  _checkPayBeforeAdd = (
    run: (opts: { markPaidAfterAdd: boolean; creditIds?: string[] }) => void,
    isGuest = false,
    returnDialogType: DialogTypes | "" = "",
    playerId?: string,
  ) => {
    if (this._needsPayBeforePlayChoice(isGuest)) {
      this._openPayBeforePlayChoice(run, returnDialogType, playerId);
    } else {
      run({ markPaidAfterAdd: false });
    }
  };

  _openEditPlayerDialog = (player: Player) => {
    this.setState({
      selectedPlayer: player,
      editPlayerState: {
        group: player.group?.name || "",
        teamId: player.team?._id || "",
        startingHole: player.group?.startingHole || "",
      },
      openDialog: true,
      dialogType: DialogTypes.EDIT_PLAYER,
    });
  };

  _handleEditPlayerChange = (field: keyof EditPlayerState) => (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({
      editPlayerState: {
        ...this.state.editPlayerState,
        [field]: event.target.value,
      },
    });
  };

  _handleSavePlayer = () => {
    const { selectedPlayer, editPlayerState } = this.state;
    if (!selectedPlayer) return;

    const game = this.getGame();
    if (!game) return;

    // Update group if changed
    if (editPlayerState.group !== (selectedPlayer.group?.name || "")) {
      this.props.addPlayerToGroup(this.props.gameId, editPlayerState.group, selectedPlayer._id);
    }

    // Update team if changed
    if (editPlayerState.teamId !== (selectedPlayer.team?._id || "")) {
      this.props.changePlayerTeam(game._id, selectedPlayer._id, editPlayerState.teamId);
    }

    // Update starting hole if changed
    if (editPlayerState.startingHole !== (selectedPlayer.group?.startingHole || "")) {
      this.props.updateGroupStartingHole(
        this.props.gameId,
        editPlayerState.startingHole as number,
        selectedPlayer._id,
        selectedPlayer.team?._id,
      );
    }

    this._toggleDialog()();
    showSnackbar(`${selectedPlayer.name} ${selectedPlayer.lastName || ""} updated.`);
  };

  _handleDeletePlayerFromDialog = () => {
    if (!this.state.selectedPlayer) return;
    this.setState({ dialogType: DialogTypes.REMOVE_PLAYER, issueRemoveCredit: false });
  };

  _cancelRemovePlayer = () => {
    this.setState({ dialogType: DialogTypes.EDIT_PLAYER, issueRemoveCredit: false });
  };

  _confirmRemovePlayer = () => {
    const { selectedPlayer, issueRemoveCredit } = this.state;
    if (!selectedPlayer) return;
    this._removePlayer(selectedPlayer, issueRemoveCredit);
    this._toggleDialog()();
  };

  _handleAddGroupFromEdit = () => {
    const { gameId } = this.props;
    const { selectedPlayer } = this.state;
    if (!selectedPlayer) return;

    showPickerDialog("New Group Name", "Text", (name: string) => {
      this.props.insertGroup(gameId, name, [selectedPlayer._id], (err) => {
        if (!err) {
          this.setState({
            editPlayerState: {
              ...this.state.editPlayerState,
              group: name,
            },
          });
          showSnackbar(`Group ${name} created and ${selectedPlayer.name} assigned.`);
        }
      });
    }, 3);
  };

  _handleAddTeamFromEdit = () => {
    const { gameId } = this.props;
    const { selectedPlayer } = this.state;
    if (!selectedPlayer) return;

    const game = this.getGame();
    if (!game) return;

    const renderColorPicker =
      game.competition.playingRules.playingAs === PlayingAsFormats.Team &&
      game.competition.playingRules.playingFormat === PlayingFormats.Matchplay;

    showPickerDialog(
      "New Team Name",
      "Text",
      (name: string, color?: string) => {
        this.props.insertTeam(name, gameId, color, (err: any, team: any) => {
          if (!err && team) {
            this.setState({
              editPlayerState: {
                ...this.state.editPlayerState,
                teamId: team._id,
              },
            });
            showSnackbar(`Team ${name} created and ${selectedPlayer.name} assigned.`);
          }
        });
      },
      3,
      null,
      null,
      true,
      false,
      renderColorPicker,
    );
  };

  _renderEditPlayerDialog = () => {
    const { classes } = this.props;
    const { selectedPlayer, editPlayerState } = this.state;
    const game = this.getGame();

    if (!selectedPlayer || !game) return null;

    return (
      <DialogContent className={classes.editPlayerContent}>
        <div className={classes.playerHeader}>
          {selectedPlayer.avatar ? (
            <img
              src={config.API_URL + selectedPlayer.avatar}
              alt={selectedPlayer.name}
              className={classes.playerAvatar}
              style={{ objectFit: "cover" }}
            />
          ) : (
            <div className={classes.playerAvatar}>
              {(selectedPlayer.name?.[0] || "").toUpperCase()}
              {(selectedPlayer.lastName?.[0] || "").toUpperCase()}
            </div>
          )}
          <Typography variant="h6" className={classes.playerName}>
            {selectedPlayer.name} {selectedPlayer.lastName || ""}
          </Typography>
          <Typography variant="body2" className={classes.playerUsername}>
            @{selectedPlayer.username}
          </Typography>
          <div className={classes.handicapInfo}>
            <div className={classes.handicapCard}>
              <span className={classes.handicapLabel}>Course HCP</span>
              <span className={classes.handicapValue}>{getHandicapDisplay(selectedPlayer.courseHandicap)}</span>
            </div>
            <div className={classes.handicapCard}>
              <span className={classes.handicapLabel}>Playing HCP</span>
              <span className={classes.handicapValue}>{getHandicapDisplay(selectedPlayer.playingHcp)}</span>
            </div>
          </div>
        </div>

        <div className={classes.formSection}>
          <div className={classes.fieldWithAction}>
            <FormControl fullWidth className={classes.formField} variant="outlined" size="small">
              <InputLabel id="edit-group-label">Group</InputLabel>
              <Select
                labelId="edit-group-label"
                label="Group"
                value={editPlayerState.group}
                onChange={this._handleEditPlayerChange("group")}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {this.getGroups().map((item: any) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Tooltip title="Create new group">
              <IconButton size="small" className={classes.inlineAddBtn} onClick={this._handleAddGroupFromEdit}>
                <Add fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>

          <div className={classes.fieldWithAction}>
            <FormControl fullWidth className={classes.formField} variant="outlined" size="small">
              <InputLabel id="edit-team-label">Team</InputLabel>
              <Select
                labelId="edit-team-label"
                label="Team"
                value={editPlayerState.teamId}
                onChange={this._handleEditPlayerChange("teamId")}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {this._getUniqueTeams().map((item: any) => (
                  <MenuItem key={item._id} value={item._id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Tooltip title="Create new team">
              <IconButton size="small" className={classes.inlineAddBtn} onClick={this._handleAddTeamFromEdit}>
                <Add fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>

          <FormControl fullWidth className={classes.formField} variant="outlined" size="small">
            <InputLabel id="edit-hole-label">Start Hole</InputLabel>
            <Select
              labelId="edit-hole-label"
              label="Start Hole"
              value={editPlayerState.startingHole}
              onChange={this._handleEditPlayerChange("startingHole")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {game.startingTees?.map((i: number) => (
                <MenuItem key={i} value={i}>
                  {i}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="outlined"
            fullWidth
            className={classes.deleteFieldBtn}
            onClick={this._handleDeletePlayerFromDialog}
            startIcon={<Delete />}
          >
            Delete Player
          </Button>
        </div>
      </DialogContent>
    );
  };

  _renderRemovePlayerDialog = () => {
    const { classes } = this.props;
    const { selectedPlayer, issueRemoveCredit } = this.state;
    const game = this.getGame();
    if (!selectedPlayer || !game) return null;

    const playerName =
      `${selectedPlayer.name || ""} ${selectedPlayer.lastName || ""}`.trim() || selectedPlayer.username || "This player";
    const paid = selectedPlayer.payStatus === PayStatus.PAID;

    return (
      <DialogContent className={classes.removePlayerContent}>
        <Typography className={classes.removePlayerLead}>
          <strong>{playerName}</strong> will be removed from <strong>{game.name}</strong>.
        </Typography>
        {paid ? (
          <>
            <Typography className={classes.removePlayerMeta}>
              They stay on Players who left as Removed by admin. No email is sent.
            </Typography>
            <FormControlLabel
              className={`${classes.creditChoice} ${issueRemoveCredit ? classes.creditChoiceOn : ""}`}
              control={
                <Checkbox
                  color="secondary"
                  checked={issueRemoveCredit}
                  onChange={(_e, checked) => this.setState({ issueRemoveCredit: checked })}
                />
              }
              label={
                <span className={classes.creditChoiceText}>
                  <span className={classes.creditChoiceTitle}>Issue game credit</span>
                  <span className={classes.creditChoiceHint}>
                    They can use it toward a rejoin or a later game with this organiser.
                  </span>
                </span>
              }
            />
          </>
        ) : null}
      </DialogContent>
    );
  };

  _renderDialogContent = () => {
    switch (this.state.dialogType) {
      case DialogTypes.ADD_GUEST:
        return (
          <GuestPlayerForm
            displayText
            onSubmit={(formValue: GuestPlayerInputs, cb: () => void) => {
              this._checkPayBeforeAdd(
                ({ markPaidAfterAdd }) => {
                  this._addPlayer(null, formValue, cb, markPaidAfterAdd);
                },
                true,
                DialogTypes.ADD_GUEST,
              );
            }}
          />
        );
      case DialogTypes.REMOVE_GROUP:
        return (
          <RemoveDialogContent
            items={this.getGroups()}
            gameId={this.props.gameId}
            onClose={this._toggleDialog()}
            type="Group"
          />
        );
      case DialogTypes.REMOVE_TEAM:
        return (
          <RemoveDialogContent
            items={this._getTeamNames()}
            gameId={this.props.gameId}
            onClose={this._toggleDialog()}
            type="Team"
          />
        );
      case DialogTypes.ADD_GROUP:
        return (
          <GroupCreation organiser={true} routerProps={{ gameId: this.props.gameId }} onSubmit={this._toggleDialog()} />
        );
      case DialogTypes.SEARCH_PLAYERS:
        return this.renderSearchContent();
      case DialogTypes.PAY_BEFORE_PLAY_ADD:
        return (
          <PayBeforePlayAddPlayerChoice
            onConfirm={(choice, creditIds) => this._handlePaymentChoice(choice, creditIds)}
            onCancel={this._handlePaymentChoiceCancel}
            credit={this.state.addPlayerCredit}
            creditLoading={this.state.addPlayerCreditLoading}
          />
        );
      case DialogTypes.EDIT_PLAYER:
        return this._renderEditPlayerDialog();
      case DialogTypes.REMOVE_PLAYER:
        return this._renderRemovePlayerDialog();
      default:
        return null;
    }
  };

  renderDialogs() {
    const { classes } = this.props;
    const { dialogType } = this.state;
    const toolbarProps = dialogType ? toolbarConfig[dialogType] : {};

    const isEditPlayer = dialogType === DialogTypes.EDIT_PLAYER;
    const isPaymentChoice = dialogType === DialogTypes.PAY_BEFORE_PLAY_ADD;
    const isRemovePlayer = dialogType === DialogTypes.REMOVE_PLAYER;
    const compactDialog = isEditPlayer || isPaymentChoice || isRemovePlayer;
    const onDialogClose = isPaymentChoice
      ? this._handlePaymentChoiceCancel
      : isRemovePlayer
      ? this._cancelRemovePlayer
      : this._toggleDialog();

    return (
      <Dialog
        open={this.state.openDialog}
        onBackdropClick={onDialogClose}
        className={dialogType === "SEARCH_PLAYERS" ? classes.searchDialog : ""}
        fullWidth={compactDialog}
        maxWidth={compactDialog ? "xs" : undefined}
      >
        <DialogToolbar {...toolbarProps} onClick={onDialogClose} />
        {this._renderDialogContent()}
        {isEditPlayer && (
          <DialogActions className={classes.dialogActions}>
            <Button onClick={this._toggleDialog()} color="default">
              Cancel
            </Button>
            <Button onClick={this._handleSavePlayer} color="primary" variant="contained">
              Save
            </Button>
          </DialogActions>
        )}
        {isRemovePlayer && (
          <DialogActions className={classes.dialogActions}>
            <Button onClick={this._cancelRemovePlayer} color="default">
              Cancel
            </Button>
            <Button onClick={this._confirmRemovePlayer} variant="contained" className={classes.removeConfirmBtn}>
              Remove
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }

  renderSearchContent = () => {
    const { searchRes, searchTxt } = this.state;
    const { classes, players, user } = this.props;

    return (
      <DialogContent>
        <InputBase
          value={searchTxt}
          placeholder={"Input username or email"}
          className={classes.searchInput}
          inputProps={{ autoFocus: true }}
          onChange={this._onTextFieldChanged("searchTxt")}
          startAdornment={
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          }
          endAdornment={
            searchTxt && (
              <InputAdornment position="end">
                <IconButton onClick={this._clear}>
                  <Close fontSize="small" />
                </IconButton>
              </InputAdornment>
            )
          }
        />

        {searchRes?.length ? (
          <List>
            {searchRes.map((item: any) => {
              const alreadyAdded = !!players.find((p: Player) => p._id === item._id);
              return (
                <ListItem
                  button
                  disabled={alreadyAdded}
                  onClick={() => {
                    this._checkPayBeforeAdd(
                      ({ markPaidAfterAdd, creditIds }) => {
                        this._addPlayer(item, undefined, undefined, markPaidAfterAdd, creditIds);
                      },
                      false,
                      DialogTypes.SEARCH_PLAYERS,
                      item._id,
                    );
                  }}
                >
                  <ListItemIcon>
                    <Checkbox edge="start" checked={alreadyAdded} disableRipple />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <span className={classes.searchPlayerNameLine}>
                        <span>{`${item.name} ${item.lastName || ""}`}</span>
                        <PlayerFavouriteToggle
                          playerId={item._id}
                          currentUserId={user?._id}
                          favPlayerIds={user?.favPlayers}
                          onToggle={this.togglePlayerFavourite}
                        />
                      </span>
                    }
                    secondary={item.username}
                  />
                </ListItem>
              );
            })}
          </List>
        ) : (
          searchTxt.length >= this.props.minChar && (
            <div className={classes.guestContainer}>
              <Typography color="secondary">
                Player not registered ?
                <br />
                Add as a Guest
              </Typography>

              <Tooltip title="add guest player" leaveTouchDelay={2000}>
                <IconButton onClick={this._toggleDialog(DialogTypes.ADD_GUEST)}>
                  <PersonAdd color="secondary" />
                </IconButton>
              </Tooltip>
            </div>
          )
        )}
      </DialogContent>
    );
  };

  handleRequestSort = (property: string) => (event: React.MouseEvent<unknown>) => {
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    this.setState({ order: isAsc ? "desc" : "asc", orderBy: property });
  };

  customizedSortHandler = (players: any) => {
    const { order, orderBy } = this.state;
    let sorted = [...players];

    if (orderBy === "team") {
      sorted.sort((a: any, b: any) => {
        const teamA = a.team?.name || "";
        const teamB = b.team?.name || "";
        return sortByGroupName(teamA, teamB);
      });
    } else if (orderBy === "name") {
      sorted.sort((a: any, b: any) => {
        const nameA = a.lastName ? a.lastName.toLowerCase() : a.name.toLowerCase();
        const nameB = b.lastName ? b.lastName.toLowerCase() : b.name.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    } else if (orderBy === "startHole") {
      sorted.sort((a: any, b: any) => (a.group?.startingHole || 0) - (b.group?.startingHole || 0));
    } else if (orderBy === "courseHandicap") {
      sorted.sort((a: any, b: any) => (a.courseHandicap || 0) - (b.courseHandicap || 0));
    } else if (orderBy === "playingHcp") {
      sorted.sort((a: any, b: any) => (a.playingHcp || 0) - (b.playingHcp || 0));
    } else {
      // Default Group Sorting Logic (Order By 'group' or default)
      let PlayersWithGroup = [];
      let PlayersWithoutGroup = [];
      for (let i = 0; i < players.length; i++) {
        if (!players[i].group || !players[i].group.name) {
          PlayersWithoutGroup.push(players[i]);
        }
        if (players[i].group && players[i].group.name) {
          PlayersWithGroup.push(players[i]);
        }
      }
      PlayersWithGroup.sort((a: any, b: any) => {
        const { startingHole: sth1 = 1, name: nm1 } = a.group;
        const { startingHole: sth2 = 1, name: nm2 } = b.group;
        // First sort them by Start Hole
        if (sth1 !== sth2) {
          return sth1 - sth2;
        }

        return sortByGroupName(nm1, nm2);
      });
      PlayersWithoutGroup.sort((a: any, b: any) =>
        a["lastName"] < b["lastName"] ? -1 : a["lastName"] > b["lastName"] ? 1 : 0,
      );
      sorted = [...PlayersWithGroup, ...PlayersWithoutGroup];
    }

    if (orderBy !== "group" && order === 'desc') {
      return sorted.reverse();
    }
    return order === "desc" && orderBy === "group" ? sorted.reverse() : sorted;
  };

  _updatePH = () => {
    const game = this.getGame();
    if (game) {
      const playerIds = this.props.players.map(p => p._id);
      this.props.updatePlayersPH(game._id, playerIds);
    }
  };

  _updateStartHole = (p: Player, value: number) => {
    if (this.props.gameId) this.props.updateGroupStartingHole(this.props.gameId, value, p._id, p.team?._id);
  };

  renderMobileControls = () => {
    const { classes } = this.props;
    const { order, orderBy } = this.state;
    const game = this.getGame();
    if (!game) return null;

    const groupCount = (game.groups ?? []).length;
    const teamCount = (game.teams ?? []).length;

    return (
      <div className={classes.mobileControls}>
        <div className={classes.sortRow}>
          <div className={classes.sortControls}>
            <Sort fontSize="small" style={{ marginRight: "0.5rem", color: "#333" }} />
            <span style={{ fontWeight: 600, color: "#333" }}>Sort by:</span>
            <FormControl className={classes.margin}>
              <Select
                value={orderBy}
                onChange={(e: any) => this.setState({ orderBy: e.target.value })}
                disableUnderline
                style={{ fontSize: "0.875rem", fontWeight: 600, color: "#333" }}
              >
                <MenuItem value="group">Group</MenuItem>
                <MenuItem value="team">Team</MenuItem>
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="startHole">Start Hole</MenuItem>
                <MenuItem value="courseHandicap">CH</MenuItem>
                <MenuItem value="playingHcp">PH</MenuItem>
              </Select>
            </FormControl>
            <IconButton
              size="small"
              onClick={() => this.setState({ order: order === "asc" ? "desc" : "asc" })}
              style={{ color: "#333" }}
            >
              {order === "asc" ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />}
            </IconButton>
          </div>
          <VideoPopup videoURL={HELP_VIDEOS.PLAYERS_GROUPS} />
        </div>

        <div className={classes.actionControls}>
          <div className="action-group">
            <IconButton size="small" color="primary" onClick={this._toggleDialog(DialogTypes.ADD_GROUP)}>
              <Add fontSize="small" />
            </IconButton>
            <span className="label">Group</span>
            <IconButton
              size="small"
              color="secondary"
              disabled={!groupCount}
              onClick={this._toggleDialog(DialogTypes.REMOVE_GROUP)}
            >
              <RemoveCircle fontSize="small" />
            </IconButton>
          </div>

          <div className="action-group">
            <IconButton size="small" color="primary" onClick={this._toggleNewTeamDialog}>
              <Add fontSize="small" />
            </IconButton>
            <span className="label">Team</span>
            <IconButton
              size="small"
              color="secondary"
              disabled={!teamCount}
              onClick={this._toggleDialog(DialogTypes.REMOVE_TEAM)}
            >
              <RemoveCircle fontSize="small" />
            </IconButton>
          </div>
        </div>
      </div>
    );
  };

  renderTable() {
    const { classes, players: ps, isLoading } = this.props;

    const game = this.getGame();
    if (!game) return <LinearProgress />;

    const players = ps
      .filter(x => !x.isTeamCard)
      .sort((a: any, b: any) => (a.group && b.group && a.group.name > b.group.name ? 1 : -1));

    return (
      <>
        <Toolbar className={classes.responsiveToolbar}>
          <Button
            disableElevation
            variant="contained"
            className={classes.linkBtn}
            startIcon={<PictureAsPdf color="primary" />}
            onClick={this.props.onSwitchClick}
          >
            Start Sheet
          </Button>

          {players.length > 0 && (
            <Button className={classes.rBtn} variant="outlined" color="secondary" onClick={this._updatePH}>
              Update Players PH
            </Button>
          )}
          <Tooltip title="add player" leaveTouchDelay={2000}>
            <IconButton aria-label="add player" onClick={this._toggleDialog(DialogTypes.SEARCH_PLAYERS)}>
              <PersonAdd style={{ color: "#399e39" }} />
            </IconButton>
          </Tooltip>
        </Toolbar>
        {this.renderMobileControls()}
        <TableContainer className={classes.paper} style={{ opacity: isLoading ? "0.3" : "1" }}>
          {players.length > 0 && (
            <Table className={classes.table} stickyHeader>
              <TableHead>
                <TableRow>
                  <TightHeaderCell>
                    <TableSortLabel
                      active={this.state.orderBy === "name"}
                      direction={this.state.orderBy === "name" ? this.state.order : "asc"}
                      onClick={this.handleRequestSort("name")}
                    >
                      <span>Name</span>
                    </TableSortLabel>
                  </TightHeaderCell>
                  <TightHeaderCell align="center">
                    <TableSortLabel
                      active={this.state.orderBy === "group"}
                      direction={this.state.orderBy === "group" ? this.state.order : "asc"}
                      onClick={this.handleRequestSort("group")}
                    >
                      Group
                    </TableSortLabel>
                  </TightHeaderCell>
                  <TightHeaderCell align="center">
                    <TableSortLabel
                      active={this.state.orderBy === "team"}
                      direction={this.state.orderBy === "team" ? this.state.order : "asc"}
                      onClick={this.handleRequestSort("team")}
                    >
                      Team
                    </TableSortLabel>
                  </TightHeaderCell>
                  <TightHeaderCell align="center">
                    <TableSortLabel
                      active={this.state.orderBy === "startHole"}
                      direction={this.state.orderBy === "startHole" ? this.state.order : "asc"}
                      onClick={this.handleRequestSort("startHole")}
                    >
                      Hole
                    </TableSortLabel>
                  </TightHeaderCell>
                  <TightHeaderCell align="center">
                    <TableSortLabel
                      active={this.state.orderBy === "courseHandicap"}
                      direction={this.state.orderBy === "courseHandicap" ? this.state.order : "asc"}
                      onClick={this.handleRequestSort("courseHandicap")}
                    >
                      CH
                    </TableSortLabel>
                  </TightHeaderCell>
                  <TightHeaderCell align="center">
                    <TableSortLabel
                      active={this.state.orderBy === "playingHcp"}
                      direction={this.state.orderBy === "playingHcp" ? this.state.order : "asc"}
                      onClick={this.handleRequestSort("playingHcp")}
                    >
                      PH
                    </TableSortLabel>
                  </TightHeaderCell>
                  <TightHeaderCell align="center"></TightHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.customizedSortHandler(players).map((player: any) => {
                  return (
                    <TableRow
                      key={player._id}
                      className={classes.clickableRow}
                      onClick={() => this._openEditPlayerDialog(player)}
                    >
                      <TightBodyCell component="th" scope="row">
                        <div className={classes.playerNameCell}>
                          <span className={classes.playerNameRow}>
                            <PlayerName
                              isGuest={player.guest}
                              name={player.name}
                              lastName={player.lastName}
                              hci={player.hci}
                              player={player}
                            />
                            {game?.isPaid && <PaymentStatusBadge payStatus={player.payStatus} size="compact" />}
                          </span>
                          <span className={classes.usernameLabel}>{player.username}</span>
                        </div>
                      </TightBodyCell>
                      <TightBodyCell align="center">{player.group?.name || "-"}</TightBodyCell>
                      <TightBodyCell align="center">{player.team?.name || "-"}</TightBodyCell>
                      <TightBodyCell align="center">{player.group?.startingHole || "-"}</TightBodyCell>
                      <TightBodyCell align="center">{getHandicapDisplay(player.courseHandicap)}</TightBodyCell>
                      <TightBodyCell align="center">{getHandicapDisplay(player.playingHcp)}</TightBodyCell>
                      <TightBodyCell align="center">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            this._openEditPlayerDialog(player);
                          }}
                          style={{ color: "#666" }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </TightBodyCell>
                    </TableRow>
                  );
                })}
                {/* Add Player Row */}
                <TableRow className={classes.addPlayerRow}>
                  <TightBodyCell colSpan={7}>
                    <div
                      className={classes.addPlayerCell}
                      onClick={this._toggleDialog(DialogTypes.SEARCH_PLAYERS)}
                    >
                      <PersonAdd fontSize="small" style={{ marginRight: 6 }} />
                      Add Player
                    </div>
                  </TightBodyCell>
                </TableRow>
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </>
    );
  }
  render() {
    return (
      <>
        {this.renderTable()}
        {this.renderDialogs()}
      </>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      minWidth: 300,
      backgroundColor: "#fff",
      overflowX: "auto",
      [theme.breakpoints.down("xs")]: {
        // borderRadius: "10px",
        // boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        // border: "1px solid #ddd",
        margin: "0 8px",
        padding: 0,
      },
    },
    linkBtn: {
      marginRight: "auto",
      backgroundColor: "#eee",
      textTransform: "inherit",
      height: 36,
      borderRadius: 8,
      padding: "6px 16px",
      [theme.breakpoints.down("xs")]: {
        marginRight: "0",
        padding: "4px 12px",
        fontSize: "0.8rem",
        whiteSpace: "nowrap",
      },
    },
    usernameLabel: {
      color: "#555",
      fontSize: "0.8125rem",
      fontWeight: 500,
      lineHeight: 1.3,
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    searchInput: {
      width: 256,
    },
    searchPlayerNameLine: {
      display: "inline-flex",
      alignItems: "center",
      gap: 0,
      maxWidth: "100%",
    },
    rBtn: {
      textTransform: "inherit",
      margin: "0 1rem",
      minWidth: "10rem",
      height: 36,
      borderRadius: 8,
      padding: "6px 16px",
      [theme.breakpoints.down("xs")]: {
        margin: "0 4px",
        minWidth: "auto",
        fontSize: "0.8rem",
        padding: "4px 12px",
        whiteSpace: "nowrap",
        borderColor: "#f44336",
        color: "#f44336",
      },
    },
    responsiveToolbar: {
      [theme.breakpoints.down("xs")]: {
        flexWrap: "wrap",
        minHeight: "auto",
        padding: "8px 12px",
        justifyContent: "space-between",
        gap: "4px",
      },
    },
    searchDialog: {
      [theme.breakpoints.down("sm")]: {
        "& .MuiDialog-scrollPaper": {
          alignItems: "flex-start",
          marginTop: "20px",
        },
      },
    },
    guestContainer: {
      display: "flex",
      justifyContent: "space-between",
      margin: "15px 0",
      animation: "$fadeIn 1000ms",
    },
    "@keyframes fadeIn": {
      "0%": { opacity: 0 },
      "50%": { opacity: 0 },
      "100%": { opacity: 1 },
    },
    table: {
      minWidth: 650,
      borderCollapse: "separate",
      borderSpacing: 0,
      "& thead": {
        position: "sticky",
        top: 0,
        zIndex: 1,
        "& th": {
          borderBottom: "1px solid #ddd",
          boxShadow: "inset 0px -3px 0px #8080800f",
          fontWeight: 700,
          fontSize: "0.85rem",
          color: "#333",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          padding: "12px 16px",
          whiteSpace: "nowrap",
        },
        "& .MuiTableSortLabel-root": {
          "& .MuiTableSortLabel-icon": {
            display: "none",
          },
          "&.MuiTableSortLabel-active .MuiTableSortLabel-icon": {
            display: "inline-block",
          },
        },
      },
      "& tbody tr": {
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        "&:hover": {
          backgroundColor: "rgba(103, 58, 183, 0.04)",
        },
        "& td": {
          borderBottom: "1px solid #eee",
        },
      },
    },
    clickableRow: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
      },
    },
    playerNameCell: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 2,
      fontWeight: 600,
    },
    playerNameRow: {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "4px 6px",
    },
    mobileControls: {
      display: "flex",
      flexDirection: "column",
      padding: "12px 16px",
      backgroundColor: "#fff",
      borderRadius: "10px",
      marginBottom: "12px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      border: "1px solid #ddd",
      [theme.breakpoints.down("xs")]: {
        padding: "0px 8px 10px 8px",
        marginLeft: "8px",
        marginRight: "8px",
      },
    },
    sortRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "12px",
      borderBottom: "1px solid #ddd",
    },
    sortControls: {
      display: "flex",
      alignItems: "center",
      "& .MuiFormControl-root": {
        margin: "0 8px",
        minWidth: "auto",
      },
    },
    actionControls: {
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
      "& .action-group": {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        padding: "6px 10px",
        border: "1px solid #dadada",
        boxShadow: "inset 0px 0px 4px #80808021"
      },
      "& .label": {
        fontSize: "0.9rem",
        fontWeight: 900,
        color: "#333",
        textTransform: "uppercase",
        letterSpacing: "-0.25px",
      },
    },
    desktopOnly: {
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    removeBtnContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      width: "100%",
    },
    addPlayerRow: {
      backgroundColor: "#f9f9f9",
      "&:hover": {
        backgroundColor: "#f9f9f9",
      },
    },
    addPlayerCell: {
      color: "#399e39",
      display: "inline-flex",
      padding: "8px 4px",
      alignItems: "center",
      fontWeight: 600,
      cursor: "pointer",
      borderRadius: 6,
      transition: "background-color 0.15s",
      "&:hover": {
        backgroundColor: "rgba(57, 158, 57, 0.1)",
      },
    },
    // Edit Player Dialog Styles
    editPlayerContent: {
      maxWidth: "100%",
      padding: "0 24px 20px",
      overflow: "hidden",
      [theme.breakpoints.down("xs")]: {
        padding: "0 16px 16px",
      },
    },
    playerHeader: {
      textAlign: "center",
      paddingTop: 8,
      paddingBottom: 20,
      marginBottom: 20,
      borderBottom: "1px solid #eee",
    },
    playerAvatar: {
      width: 64,
      height: 64,
      borderRadius: "50%",
      backgroundColor: "#673ab7",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.5rem",
      fontWeight: 700,
      margin: "0 auto 12px",
      letterSpacing: 1,
    },
    playerName: {
      fontWeight: 700,
      fontSize: "1.25rem",
      color: "#333",
      marginBottom: 4,
    },
    playerUsername: {
      color: "#888",
      fontSize: "0.85rem",
      marginBottom: 12,
    },
    handicapInfo: {
      display: "flex",
      justifyContent: "center",
      gap: 12,
      marginTop: 12,
      [theme.breakpoints.down("xs")]: {
        gap: 8,
      },
    },
    handicapCard: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#f5f5f5",
      borderRadius: 8,
      padding: "8px 12px",
      flex: 1,
      minWidth: 0,
      maxWidth: 140,
    },
    handicapLabel: {
      fontSize: "0.7rem",
      color: "#888",
      textTransform: "uppercase",
      letterSpacing: 0.5,
      marginBottom: 4,
    },
    handicapValue: {
      fontSize: "1.25rem",
      fontWeight: 700,
      color: "#333",
    },
    formSection: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
    },
    formField: {
      "& .MuiOutlinedInput-root": {
        borderRadius: 8,
      },
    },
    dialogActions: {
      padding: "12px 24px 20px",
      borderTop: "1px solid #eee",
    },
    removePlayerContent: {
      padding: "8px 24px 20px",
    },
    removePlayerLead: {
      fontSize: "0.9375rem",
      fontWeight: 400,
      lineHeight: 1.5,
      color: "#0f172a",
      marginBottom: 12,
    },
    removePlayerMeta: {
      fontSize: "0.8125rem",
      fontWeight: 400,
      lineHeight: 1.45,
      color: "#64748b",
      marginBottom: 16,
    },
    creditChoice: {
      display: "flex",
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
      alignItems: "flex-start",
      width: "100%",
      padding: "10px 12px",
      borderRadius: 8,
      border: "1px solid #e2e8f0",
      transition: "border-color 0.15s ease, background-color 0.15s ease",
      "&:hover": {
        backgroundColor: "rgba(15, 23, 42, 0.02)",
      },
      "& .MuiCheckbox-root": {
        paddingTop: 6,
      },
    },
    creditChoiceOn: {
      borderColor: "#1976d2",
      backgroundColor: "rgba(25, 118, 210, 0.06)",
    },
    creditChoiceText: {
      display: "flex",
      flexDirection: "column",
      paddingTop: 4,
    },
    creditChoiceTitle: {
      fontWeight: 600,
      fontSize: "0.9375rem",
      lineHeight: 1.35,
      color: "#0f172a",
    },
    creditChoiceHint: {
      display: "block",
      marginTop: 2,
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 1.4,
      color: "#64748b",
    },
    removeConfirmBtn: {
      backgroundColor: "#f44336",
      color: "#fff",
      textTransform: "none",
      fontWeight: 600,
      borderRadius: 8,
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#d32f2f",
        boxShadow: "none",
      },
    },
    deleteBtn: {
      color: "#f44336",
      "&:hover": {
        backgroundColor: "rgba(244, 67, 54, 0.08)",
      },
    },
    deleteFieldBtn: {
      borderColor: "transparent",
      backgroundColor: "#f4433615",
      color: "#f44336",
      borderRadius: 8,
      padding: "8px 16px",
      textTransform: "none",
      fontWeight: 600,
      transition: "all 0.2s",
      "&:hover": {
        backgroundColor: "rgba(244, 67, 54, 0.05)",
        borderColor: "#f44336",
      },
    },
    fieldWithAction: {
      display: "flex",
      alignItems: "center",
      gap: 8,
    },
    inlineAddBtn: {
      color: "#399e39",
      backgroundColor: "rgba(57, 158, 57, 0.05)",
      "&:hover": {
        backgroundColor: "rgba(57, 158, 57, 0.15)",
      },
    },
  });

function mapStateToProps(state: GlobalState) {
  const { joinedGames, organisedByMe, games, players, isLoading } = state.games;
  const { user } = state.auth;
  return {
    user,
    games: { ...games, ...organisedByMe, ...joinedGames },
    players,
    isLoading,
  };
}

export default connect(mapStateToProps, {
  searchPlayersByUserName: searchPlayers,
  addPlayerToFav,
  removePlayerFromFav,
  addPlayer: GameActions.addPlayer,
  updatePlayersPH: GameActions.updatePlayersPH,
  addGuestPlayer: GameActions.addGuestPlayer,
  insertTeam: TeamActions.insertTeam,
  insertGroup: GameActions.insertGroup,
  updateTeam: TeamActions.update,
  removePlayer: GameActions.removePlayer,
  changePlayerTeam: GameActions.changePlayerTeam,
  removePlayerFromGroup: GameActions.removePlayerFromGroup,
  addPlayerToGroup: GameActions.addPlayerToGroup,
  updateGameGroup: GameActions.updateGameGroup,
  updateGroupStartingHole: GameActions.updateGroupStartingHole,
  setUpdatedResult: GameActions.setUpdatedResult,
  getGamePlayers: GameActions.getGamePlayers,
  addWithoutPayment: PaymentAction.addWithoutPayment,
})(withStyles(styles)(GamePlayersManager));
